import { Pipe, PipeTransform } from '@angular/core';
import { NgxCurrencyConfig } from 'ngx-currency';

@Pipe({
  name: 'appCurrency',
  standalone: true,
})
export class AppCurrencyPipe implements PipeTransform {
  private defaultConfig = {
    prefix: '€',
    suffix: '',
    thousands: '.',
    decimal: ',',
    precision: 2,
  };

  transform(
    value: number | string | null | undefined,
    options: Partial<NgxCurrencyConfig> = {}
  ): string {
    const config = { ...this.defaultConfig, ...options };
    const numValue = Number(value);

    if (value === null || value === undefined || isNaN(numValue)) {
      return '';
    }

    const fixedValue = numValue.toFixed(config.precision);
    const parts = fixedValue.split('.');

    let integerPart = parts[0];
    let decimalPart = parts[1] || '';

    integerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      config.thousands
    );

    let formattedNumber = integerPart;
    if (config.precision > 0 && decimalPart.length > 0) {
      formattedNumber += config.decimal + decimalPart;
    }

    return `${config.prefix}${formattedNumber}${config.suffix}`;
  }
}
